var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E5E1D341-9BBA-4818-AF84-926638BBE707@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share_WIP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Post_processing_page_delivery",
    transform: "translate(-21.000000, -183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pan_tool_alt_black_24dp",
    transform: "translate(21.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8904426,11.77 L15.0904426,10.1 C14.9604426,10.04 14.8104426,10 14.6504426,10 L14.0004426,10 L14.0004426,5.5 C14.0004426,4.12 12.8804426,3 11.5004426,3 C10.1204426,3 9.00044257,4.12 9.00044257,5.5 L9.00044257,13.65 L7.13044257,13.25 C6.94044257,13.22 6.11044257,13.1 5.40044257,13.81 L4.00044257,15.22 L9.12044257,20.41 C9.49044257,20.79 10.0004426,21 10.5304426,21 L17.0804426,21 C18.0604426,21 18.8904426,20.3 19.0504426,19.33 L19.9704426,13.89 C20.1204426,13.03 19.6804426,12.17 18.8904426,11.77 Z M17.0804426,19 L10.5304426,19 L6.83044257,15.22 L11.0004426,16.11 L11.0004426,5.5 C11.0004426,5.22 11.2204426,5 11.5004426,5 C11.7804426,5 12.0004426,5.22 12.0004426,5.5 L12.0004426,11.68 L13.7604426,11.68 L18.0004426,13.56 L17.0804426,19 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.438b8e47b0b32f49721be5254c4b2b45.svg";
export { ForwardRef as ReactComponent };